import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'

import { RECALL_EVENT_COPY } from '#app/routes/mocra+/_form+/components/recall-events/constants.ts'
import { RecallEventOverlay } from '#app/routes/mocra+/_form+/components/recall-events/overlay.tsx'
import {
	createRecallEventDraft,
	type RecallEventDraft,
} from '#app/routes/mocra+/_form+/components/recall-events/types.ts'

type Option = {
	readonly value: string
	readonly label: string
}

type Props = {
	readonly onSubmit: (draft: RecallEventDraft) => void
	readonly typeOptions: ReadonlyArray<Option>
	readonly outcomeOptions: ReadonlyArray<Option>
	readonly defaultValue?: RecallEventDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function RecallEventAdd({
	onSubmit,
	typeOptions,
	outcomeOptions,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: RecallEventDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? RECALL_EVENT_COPY.actions.addTrigger}
			</AddButton>
			<RecallEventOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				typeOptions={typeOptions}
				outcomeOptions={outcomeOptions}
				initialValue={defaultValue ?? createRecallEventDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
